<template>
  <InfoContent>
    <div class="info-lead">
      <p>
        Chaque appel passé ou reçu se note ici, avec son résultat. Ce n'est pas
        qu'un journal : le résultat déclenche la suite &mdash; un client qui ne
        répond pas reçoit un email et vous revient en rappel à J+2, un client
        qui décroche voit son action &laquo;&nbsp;Appel client&nbsp;&raquo; se
        refermer toute seule.
      </p>
    </div>

    <div class="info-section">
      <h3><i class="fas fa-phone"></i> Types d'appels</h3>
      <p>Vous pouvez enregistrer deux types d'appels :</p>
      
      <div class="info-item">
        <div class="info-item-header">
          <strong>Appel sortant</strong>
        </div>
        <div class="info-item-content">
          <p>Appel que vous effectuez vers le client pour le contacter.</p>
        </div>
      </div>
      
      <div class="info-item">
        <div class="info-item-header">
          <strong>Appel entrant</strong>
        </div>
        <div class="info-item-content">
          <p>Appel reçu du client qui vous contacte.</p>
        </div>
      </div>
    </div>
    
    <div class="info-section">
      <h3><i class="fas fa-check-circle"></i> Résultats d'appel</h3>
      <p>Selon le résultat de l'appel, le système effectue automatiquement certaines actions :</p>
      
      <div class="info-item">
        <div class="info-item-header">
          <strong>Décroché</strong>
        </div>
        <div class="info-item-content">
          <p>Le client a répondu à l'appel.</p>
          <p class="info-note">
            <i class="fas fa-info-circle"></i> Si une action "Appel client" était programmée, elle sera automatiquement supprimée.
          </p>
        </div>
      </div>
      
      <div class="info-item">
        <div class="info-item-header">
          <strong>Ne répond pas / Numéro incorrect</strong>
        </div>
        <div class="info-item-content">
          <p>Le client n'a pas répondu ou le numéro est incorrect.</p>
          <p class="info-note">
            <i class="fas fa-envelope"></i> Un email automatique est envoyé au client pour l'informer de votre tentative de contact.
          </p>
          <p class="info-note">
            <i class="fas fa-calendar"></i> Un rappel est créé pour J+2 (décalé au lundi si c'est un weekend) pour vous rappeler de rappeler le client.
          </p>
          <p class="info-note">
            <i class="fas fa-tasks"></i> La prochaine action "Appel client" est mise à jour avec la date du rappel.
          </p>
        </div>
      </div>
      
      <div class="info-item">
        <div class="info-item-header">
          <strong>Client demande un rappel</strong>
        </div>
        <div class="info-item-content">
          <p>Le client souhaite être rappelé à une date ultérieure.</p>
          <p class="info-note">
            <i class="fas fa-calendar"></i> Vous pouvez programmer un rappel à la date demandée par le client.
          </p>
        </div>
      </div>
    </div>
    
    <div class="info-section">
      <h3><i class="fas fa-edit"></i> Gestion des appels</h3>
      <p>Vous pouvez :</p>
      <ul>
        <li><strong>Ajouter un appel</strong> : Enregistrer un nouvel appel avec date, direction, résultat et notes</li>
        <li><strong>Modifier un appel</strong> : Corriger les informations d'un appel existant</li>
        <li><strong>Supprimer un appel</strong> : Retirer un appel de l'historique</li>
      </ul>
      <p class="info-note">
        <i class="fas fa-user"></i> Chaque appel est enregistré avec votre identité et la date/heure exacte.
      </p>
    </div>
    
    <div class="info-section">
      <h3><i class="fas fa-magic"></i> Actions automatiques</h3>
      <p>Lors de l'enregistrement d'un appel, le système peut automatiquement :</p>
      <ul>
        <li>Envoyer un email au client (si "Ne répond pas" ou "Numéro incorrect")</li>
        <li>Créer un rappel pour vous (si "Ne répond pas" ou "Numéro incorrect")</li>
        <li>Mettre à jour la prochaine action du devis</li>
        <li>Supprimer une action "Appel client" si le client a décroché</li>
      </ul>
    </div>
  </InfoContent>
</template>

<script setup>
import InfoContent from '../shared/InfoContent.vue'

defineEmits(['close'])
</script>

